import { ReactElement, Dispatch, SetStateAction } from 'react';
import { Card, Container, styled, useMediaQuery } from '@mui/material';
import {
  IUser,
  PDFModal,
  TabPanel,
  disableOperationsHelpDesk,
  useRoleOpContext,
} from '../common';
import { diLabels, diPanels, DiNav } from '.';
import {
  find as lfind,
  propOr as lpropOr,
  compose as lcompose,
} from 'lodash/fp';

export const DiTabs = ({
  user,
  currentTab,
  setCurrentTab,
}: {
  user: IUser;
  currentTab: number;
  setCurrentTab: Dispatch<SetStateAction<number>>;
}) => {
  const { operations } = useRoleOpContext();

  const currentLabel = lcompose(lpropOr('', `[${currentTab}].label`))(
    diLabels(operations)
  );

  const child = (
    <Wrapper>
      <section className="flex-align-items-baseline-justify-content-space-between margin-top-1 margin-left-1">
        <PDFModal
          fileUrl={'DI Team Members Tab.pdf'}
          fileLabel={'diversion investigators instructions'}
          fileDownload="diversion_investigators.pdf"
        />
        <a
          href={`${import.meta.env.VITE_DC_ENROLLMENT}`}
          target="_blank"
          rel="noreferrer">
          Request Access to Diversion Investigators Reports
        </a>
        <a
          href={`${import.meta.env.VITE_DI_REPORTS}`}
          target="_blank"
          rel="noreferrer">
          Diversion Investigators Reports
        </a>
      </section>

      <DiNav
        currentTab={currentTab}
        operations={operations}
        setCurrentTab={setCurrentTab}
      />

      {currentLabel !== '' && (
        <TabPanel value={currentTab} label={currentLabel}>
          {lfind<{
            value: number;
            panel: () => ReactElement;
          }>({ value: currentTab })(
            diPanels({
              user,
              disableOperationsHelpDsk: disableOperationsHelpDesk(operations),
            })
          )!.panel()}
        </TabPanel>
      )}
    </Wrapper>
  );

  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  return matchesGridBreakpoint ? (
    <Container maxWidth={false} data-testid="team-testid">
      <Card>{child}</Card>
    </Container>
  ) : (
    child
  );
};

const Wrapper = styled('article')(({ theme }) => ({
  minHeight: '76vh',
  overflowY: 'auto',

  '& > *+*': {
    marginTop: '2rem',
  },
}));
